const initialState = {
  accordionOpenStatus: {
    businessInfo: true,
    creditCheck: false,
    terms: false,
    installation: false,
    winbackqualified: false
  },
  contactInfo: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    unit: '',
    unitType: '',
    businessName: "",
    selectedMailType: "E"
  },
  businessInfo: {
    selected: true,
    address: "",
    city: "",
    state: "",
    zipCode: ""
  },
  shippingInfo: {
    selected: true,
    address: "",
    city: "",
    state: "",
    zipCode: ""
  },
  creditCheck: {
    customerType: 'SoleOwner',
    retryCount: 0,
    soleOwner: {
      firstName: '',
      lastName: '',
      middleInitial: '',
      isNoSsn: false,
      dob: '',
      ssn: ''
    },
    partner1: {
      firstName: '',
      lastName: '',
      middleInitial: '',
      isNoSsn: false,
      dob: '',
      ssn: ''
    },
    partner2: {
      firstName: '',
      lastName: '',
      middleInitial: '',
      isNoSsn: false,
      dob: '',
      ssn: ''
    },
    corporation: {
      billingName: '',
      taxIdNumber: ''
    }
  },
  optixData : "",
  isResetDateChange :true,
  nextButtonInfo: '',
  checkoutResponse: '',
  dueDate: '',
  timeSlot: '',
  timeSlotCode: '',
  busStartHour: '',
  busEndHour: '',
  tosCheck: false,
  isPersonalInfoSaved: false,
  isCreditCheckInfoSaved: false,
  isInstallmentsInfoSaved: false,
  isInstallationInfoSaved: false,
  isTosInfosaved: false,
  nextButtonBI: '',
  nextButtonCC: '',
  nextButtonIPM: '',
  appointmentCode: '',
  duedateReserveError: '',
  APEnrolled: false,
  dueDateInfo: {},
  APLoading: false,
  APLoadFailure: false,
  omniCartInfo: '',
  submitOrderInfo : '',
  omniOloDetails: {},
  omniCartError: false,
  optixEpSessionId: '',
  saveSelectedDate :''
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_BUSINESSINFO_ACCOR_OPTIX':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: !state.accordionOpenStatus.businessInfo,
          creditCheck: false,
          winbackqualified: false,
          terms: false,
          installment: false,
          installation: false
        }
      }
    case 'TOGGLE_CREDITCHECK_ACCOR_OPTIX':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: !state.accordionOpenStatus.creditCheck,
          winbackqualified: false,
          terms: false,
          installment: false,
          installation: false
        }
      }
      case 'TOGGLE_WINBACKQUALIFIED_ACCOR_OPTIX':
      return {
        ...state, accordionOpenStatus: {
            businessInfo: false,
            creditCheck: false,
            winbackqualified: !state.accordionOpenStatus.winbackqualified,
            terms: false,
            installment: false,
            installation: false
        }
      }
    case 'TOGGLE_TERMS_ACCOR_OPTIX':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: false,
          winbackqualified: false,
          terms: !state.accordionOpenStatus.terms,
          installment: false,
          installation: false
        }
      }
    case 'TOGGLE_INSTALLATION_ACCOR_OPTIX':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: false,
          installation: !state.accordionOpenStatus.installation,
          installment: false,
          winbackqualified: false,
          terms: false
        }
      }
    case 'SAVE_PERSONAL_INFO_OPTIX':
      return {
        ...state,
        contactInfo: action.data.contactInfo,
        businessInfo: action.data.businessInfo,
        shippingInfo: action.data.shippingInfo
      }
    case 'SAVE_CREDIT_CHECK_INFO_OPTIX':
      return {
        ...state,
        creditCheck: {
          ...state.creditCheck,
          customerType: action.data.customerType,
          soleOwner: action.data.soleOwner,
          partner1: action.data.partner1,
          partner2: action.data.partner2,
          corporation: action.data.corporation,
        }
      }

    case "SAVE_NEXTBUTTON_INFO":
      return {
        ...state, nextButtonInfo: action.data
      }

    // case "SAVE_SUBMITORDER_INFO":
    //   return {
    //     ...state, submitOrderInfo: action.data
    //   }

    case "SAVE_SUBMITORDER_INFO_OPTIX":
      return {
        ...state, submitOrderInfo: action.data
      }


    case "UPDATE_TOS_INFO_OPTIX":
      return {
        ...state, [action.data.key]: action.data.value
      }

      case "SAVE_SELECTED_DATE":
      return {
       ...state, saveSelectedDate: action.data
      }
      

    case "SAVE_CHECKOUT_RESPONSE":
      return {
        ...state,
        contactInfo: { ...state.contactInfo, ...action.data.checkoutData.contactInfo },
        businessInfo: { ...state.businessInfo, ...action.data.checkoutData.businessInfo },
        shippingInfo: { ...state.shippingInfo, ...action.data.checkoutData.shippingInfo },
        checkoutResponse: action.data.response
      }

    case "SAVE_CHECKOUT_INSTALLMENTS":
      return {
        ...state,
        checkoutResponse: action.data.response
      }

    case "SAVE_BI_VALIDATION_RESPONSE_OPTIX":
      return {
        ...state, nextButtonBI: action.data
      }

    case "SAVE_CC_RESPONSE_OPTIX":
      return {
        ...state, nextButtonCC: action.data
      }

    case "SAVE_IPM_RESPONSE":
      return {
        ...state, nextButtonIPM: action.data
      }

    case "ACCORDION_COMPLETED_OPTIX":
      return {
        ...state, [action.data.key]: action.data.value
      }

    case "UPDATE_RETRY_COUNT_OPTIX":
      return {
        ...state, creditCheck: { ...state.creditCheck, retryCount: action.data }
      }

    case "UPDATE_CREDIT_CHECK_STATUS_OPTIX":
      return {
        ...state, nextButtonCC: { ...state.nextButtonCC, CreditCheckStatus: action.data }
      }

    case "RESERVE_DUEDATE_ERROR_OPTIX":
      return {
        ...state, duedateReserveError: action.message
      };

    case "SET_DUE_DATES_OPTIX":
      console.log(action.data)
      return {
        ...state,
        dueDateInfo: action.data.response
      };

      case "SET_OPTIX_OPTION_FIELD":
               return {
          ...state,
          optixData: action.data.response
        };

      case "IS_OPTIX_RESPONSE":      
      return {
        ...state,
        isOptix: action.data
      };

      case "IS_RESET_DATE_CHANGE":      
      return {
        ...state,
        isResetDateChange: action.data
      };
      

    case "UPDATE_SI_INFO_OPTIX":
      return {
        ...state, SelforTechInstall: {
          ...state.SelforTechInstall, [action.data.key]: action.data.value
        }
      }

    case "UPDATE_COVID_INFO_OPTIX":
      return {
        ...state, SetCovid19QuestionValue: {
          ...state.SetCovid19QuestionValue, [action.data.key]: action.data.value
        }
      }

    case "RESERVER_DUE_DATE_OPTIX": {
      return {
        ...state, SetDueDate: action.data
      }
    }

    case "SAVE_OMNI_CART_INFO": {
      return {
        ...state, omniCartInfo: action.data
      }
    }

    case "SAVE_ADDRESS_OMNI_CART_FLOW": {
      return {
        ...state, userAddress: action.data
      }
    }

    case "SAVE_OMNI_OLO_DETAILS": {
      return {
        ...state, omniOloDetails: action.data
      }
    }

    case "OMNI_SAVE_SUBMITORDER_INFO": {
      return {
        ...state, optixSubmitOrderInfo: action.data
      }
    }

    case "UPDATE_OMNI_CART_ERROR": {
      return {
        ...state, omniCartError: action.data
      }
    }

    case "SAVE_OPTIX_EPSESSION_ID": {
      return {
        ...state, optixEpSessionId: action.data
      }
    }

    case 'AUTOFILL_DATA_FOR_OPTIX_CREDITCHECK':
      return {
        ...state,
        creditCheck: {
          ...state.creditCheck,
          soleOwner: {
            ...state.creditCheck.soleOwner,
            firstName: action.data.firstName,
            lastName: action.data.lastName
          },
          partner1: {
            ...state.creditCheck.partner1,
            firstName: action.data.firstName,
            lastName: action.data.lastName
          }
        }
      }

   /* case "SAVE_OMNI_LOA_CONFIRMATION":{
      return {
        ...state, omniLOA: action.data
      }
    }*/

    default:
      return state;
  }
};
export default reducer;